

import '../pages/Gachapon.scss';
import { useLottie } from "lottie-react";
import { useEffect, useState } from "react";


  const GachaponError = ({errorMessage, hideError} : {errorMessage: string, hideError: () => void}) => {
    

    useEffect(() => {
       
    }, [errorMessage])

      return (
        <div className={`Gachapon--Error ${(errorMessage!=="") ? "show" : ""}`}>
            <div className={`Gachapon--Error--Content`}>
                <div className="Gachapon--Error--Title">Something went flippin' wrong!</div>
                <div className="Gachapon--Error--Text">{errorMessage}</div>
                <button className='Gachapon--Error--Close' onClick={() => {hideError(); }}>Try again</button>
            </div>
            
        </div>
      )

  }

  export default GachaponError;